<div class="cookie-policy">
  <p class="cookie-policy__eyebrow" i18n>LEGAL &amp; PRIVACY POLICIES</p>
  <p class="cookie-policy__effective" i18n>Effective April 27, 2026</p>

  <p>
    <a
      href="javascript:void(0)"
      (click)="onViewPreferences()"
      data-e2e="cookie-policy-view-preferences"
      i18n
      >View and change your current cookie preferences.</a
    >
  </p>

  <h3 i18n>Introduction</h3>
  <p i18n>
    This Cookie Policy describes how Verifone, Inc. (&quot;Verifone&quot;, &quot;we&quot;,
    &quot;us&quot;, &quot;our&quot;) uses cookies and similar technologies to improve your experience
    on our websites. Our commitment to your privacy is paramount, and we aim to be transparent in
    our data practices.
  </p>

  <h3 i18n>What are cookies?</h3>
  <p i18n>
    Cookies are small text files placed on your device when you visit websites, essential for
    improving functionality and user experience.
  </p>
  <p i18n>
    There are two main types of cookies that can be placed on your device when you visit our
    websites:
  </p>
  <p i18n>
    First-party cookies: these cookies are placed and read by Verifone directly when you use our
    websites. Third-party cookies: these cookies are not set by us, but by third-party providers,
    including Pendo (Pendo.io, Inc.), Google Analytics, Hotjar, New Relic, and others, for purposes
    such as product analytics, site performance monitoring, and advertising.
  </p>

  <h3 i18n>Types of Cookies We Use</h3>
  <p i18n>We use various cookies on our website, categorized as follows:</p>
  <ul>
    <li i18n>
      <strong>Essential Cookies:</strong> Necessary for website functionality and enable basic
      functions like page navigation and access to secure areas.
    </li>
    <li i18n>
      <strong>Performance and Functionality Cookies:</strong> Improve website performance. They help
      in remembering your preferences and enable personalized features.
    </li>
    <li i18n>
      <strong>Analytics and Customization Cookies:</strong> to help us understand website usage.
      These types of cookies collect information in an aggregate form to help us understand how
      people reach and use our websites and give us insights into improvements or enhancements we
      need to make to our websites. We also use technologies like web beacons on our websites and in
      some of our emails. Web beacons (also known as Pixel tags and clear GIFs) are tiny graphics
      files that contain a unique identifier enabling us to recognize when someone has visited our
      websites or opened an email that we have sent. For a full list of the analytics and product
      analytics cookies we use, including details of the data collected and retention periods,
      please see our
      <a [href]="cookieDeclarationUrl" target="_blank" data-e2e="cookie-declaration-link"
        >Cookie Declaration</a
      >.
    </li>
    <li i18n>
      <strong>Advertising Cookies:</strong> We and our service providers use cookies and similar
      technologies on our websites to direct Verifone ads to you through targeted advertisements for
      Verifone services on other sites you visit and to measure your engagement with those ads.
    </li>
    <li i18n>
      <strong>Third-Party Cookies:</strong> We partner with third-party services, which may also use
      cookies. These are used for various purposes, such as analytics or advertising.
    </li>
  </ul>
  <p i18n>
    For a complete list of cookies, please visit our
    <a [href]="cookieDeclarationUrl" target="_blank" data-e2e="cookie-preference-tool"
      >Cookie Preference tool</a
    >.
  </p>

  <h3 i18n>Managing Your Cookie Preferences</h3>
  <p i18n>
    You can manage your preferences through our website's
    <a
      href="javascript:void(0)"
      (click)="onViewPreferences()"
      data-e2e="cookie-management-tool"
      >cookie management tool</a
    >, with the exception of those cookies that are necessary to provide you with our services, or
    through your browser settings.
  </p>
  <p i18n>
    If you choose to disable cookies, some features of our websites may not operate as intended.
  </p>

  <div
    class="cookie-policy__consent"
    *ngIf="hasConsentDetails"
    data-e2e="cookie-consent-details"
  >
    <p class="cookie-policy__consent-domains" data-e2e="cookie-consent-domains">
      <span i18n>Your consent applies to the following domains:</span>
      {{ consentDomains.join(', ') }}
    </p>
    <p>
      <span i18n>Your current state:</span>
      <span data-e2e="cookie-consent-state"> {{ consentStateLabel }}</span>
    </p>
    <p *ngIf="consentId">
      <span i18n>Your consent ID:</span>
      <span data-e2e="cookie-consent-id"> {{ consentId }}</span>
    </p>
    <p *ngIf="consentDate">
      <span i18n>Consent date:</span>
      <span data-e2e="cookie-consent-date"> {{ consentDate }}</span>
    </p>
    <p class="cookie-policy__consent-actions">
      <a
        href="javascript:void(0)"
        (click)="onChangeConsent()"
        data-e2e="cookie-consent-change"
        i18n
        >Change your consent</a
      >
      <span class="cookie-policy__consent-separator">|</span>
      <a
        href="javascript:void(0)"
        (click)="onWithdrawConsent()"
        data-e2e="cookie-consent-withdraw"
        i18n
        >Withdraw your consent</a
      >
    </p>
  </div>

  <h3 i18n>Consent and Adjusting Preferences</h3>
  <p i18n>
    We require your consent for non-essential cookies. You can adjust your preferences at any time
    through our
    <a
      href="javascript:void(0)"
      (click)="onViewPreferences()"
      data-e2e="cookie-management-tool-2"
      >cookie management tool</a
    >.
  </p>

  <h3 i18n>Updates to This Policy</h3>
  <p i18n>
    We may update this policy to reflect changes in our practices or legal requirements. Please
    review this policy periodically for any changes.
  </p>

  <h3 i18n>International Considerations</h3>
  <p i18n>
    Our website is accessed globally, and we adhere to various international privacy laws. This may
    involve different cookie practices in different regions.
  </p>

  <h3 i18n>Contact Information</h3>
  <p i18n>
    For any questions or concerns regarding our cookie policy, please contact us at
    <a href="mailto:privacy@verifone.com">privacy&#64;verifone.com</a>.
  </p>

  <h3 i18n>More Information</h3>
  <p i18n>
    For more detailed information about our data practices, please refer to our
    <a [href]="privacyPolicyLink" target="_blank" data-e2e="cookie-policy-privacy-link"
      >Privacy Policy</a
    >.
  </p>
</div>
